import { EmptyValue } from '@/components/custom/empty-value'
import { HighlightedText } from '@/components/custom/highlighted-text'
import { Button } from '@/components/ui/button'
import { createMemoCell } from '@/lib/create-memo-cell'
import { cn } from '@/lib/utils'

interface CellLinkProps {
  value: string | null | undefined
  onClick?: () => void
  searchTerm?: string
}

function CellLinkBase({ value, onClick, searchTerm }: CellLinkProps) {
  if (value === null || value === undefined || value === '') {
    return <EmptyValue />
  }

  const displayValue = String(value)

  // Highlight search term if provided
  const highlightedContent = searchTerm ? (
    <HighlightedText text={displayValue} highlight={searchTerm} />
  ) : (
    displayValue
  )

  return (
    <Button
      variant="link"
      onClick={(e) => {
        e.stopPropagation()
        onClick?.()
      }}
      className={cn(
        'h-auto p-0 justify-start overflow-hidden max-w-full min-w-0',
        'text-primary hover:underline text-[length:inherit] font-normal'
      )}
    >
      <span className="truncate">{highlightedContent}</span>
    </Button>
  )
}

export const CellLink = createMemoCell(CellLinkBase, 'CellLink')
export type { CellLinkProps }
